module.exports = __webpack_public_path__ + "static/media/The Isle of Skye.89d175ca.jpg";